module.exports = __webpack_public_path__ + "static/img/disabled_page.a8cd0b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/survey/disabled_page.png
// module id = P+xS
// module chunks = 1